<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeVentesForClient.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeVentesForClient.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeVentesForClient.filtre.reference')">
            <b-input v-model="critereRecherche.referenceProduit">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeVentesForClient.filtre.libelle')">
            <b-input v-model="critereRecherche.libelleProduit">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                        :label="$t('listeVentesForClient.filtre.typesProduits')"
                        :items="categorieProduit"
                        v-model="critereRecherche.typesProduits">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                        :label="$t('listeVentesForClient.filtre.etat')"
                        :items="etatsDisponibles"
                        v-model="critereRecherche.etat">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeVentesForClient.filtre.ville')">
            <ville-tag-input-auto-complete
                :critere-recherche="this.critereRecherche"
                table-name="Produit"/>
          </b-field>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('listeVentesForClient.filtre.commercial')"
                        :blocked="userIsCommercialBlocked"
                        v-model="commercialSelected"
                        :items="listeCommercial">
          </user-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <input-periode
            v-model="critereRecherche.datesEtVenteDivers"
            orientation= 'top'
            :label="$t('listeVentesForClient.filtre.dateVentes')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0" v-if="moduleSecteurActive">
          <secteur-tag-input v-model="secteursSelected"
            :label="$t('listeFactures.filtre.secteur')"
            :critere="(el) => el.type === constantes.COMMERCIAL"
            :disabled="secteurCurrentUser.length > 0">
          </secteur-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('listeVentesForClient.filtre.actions.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('listeVentesForClient.filtre.actions.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import inputPeriode from '@/components/general/inputPeriode';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import userTagInput from '@/components/general/tagInput/userTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import secteurTagInput from '@/components/commun/secteur/secteurTagInput';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import { COMMERCIAL as SECTEURCOMMERCIAL } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser from '@/services/commun/secteur/getSecteurs';
import {
  DEVIS_ETAT,
  COMMANDE_ETAT,
  TYPE_DEVIS,
  TYPE_COMMANDE,
  TYPE_FACTURE,
} from '@/configuration/devisConf';
import { FACTURE_ETAT } from '@/configuration/facture/factureConf';

const Societes = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  components: {
    userTagInput,
    inputPeriode,
    libelleTagInput,
    VilleTagInputAutoComplete,
    secteurTagInput,
  },
  props: {
    nameStore:
        {
          type: String,
          required: true,
        },
    type: {
      type: String,
      required: true,
      validator: (value) => [TYPE_DEVIS, TYPE_FACTURE, TYPE_COMMANDE].includes(value),
    },
  },
  data() {
    return {
      critereRecherche: null,
      listeCommercial: [],
      commercialSelected: [],
      constantes: {
        COMMERCIAL: SECTEURCOMMERCIAL,
      },
      secteursSelected: [],
      secteurCurrentUser: [],
    };
  },
  computed: {
    ...Societes.mapGetters({
      societesInformations: 'societesInformations',
    }),
    critereRechercheFromStore() {
      return this.$store.getters[`${this.nameStore}/criteresRechercheVentes`];
    },
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...CategorieVente.mapGetters({
      categorieProduit: 'categorieProduit',
    }),
    userIsCommercial() {
      return (this.user.profil === COMMERCIAL);
    },
    blocageFiltreCommercial() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercialBlocked() {
      return (this.userIsCommercial && this.blocageFiltreCommercial);
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
      );
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    secteurs() {
      return this.parametre(PARAMETRES_KEYS.secteur);
    },
    etatsDisponibles() {
      if (this.type === TYPE_DEVIS) {
        return DEVIS_ETAT;
      }
      if (this.type === TYPE_FACTURE) {
        return FACTURE_ETAT;
      }
      return COMMANDE_ETAT;
    },
  },
  methods: {
    setCritereRecherche(critereRecherche) {
      this.$store.commit(`${this.nameStore}/SET_CRITERE_VENTES`, critereRecherche);
    },
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    viderCritere() {
      this.$store.commit(`${this.nameStore}/RESET_STATE`);
      this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
      this.commercialSelected = [];
      if (this.filtrerParUtilisateur && this.userIsCommercial) {
        this.critereRecherche.commercialId?.push(this.user.id);
        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.user.id === c.id;
        });
      }
      if (this.moduleSecteurActive) {
        this.secteursSelected = this.secteurCurrentUser ?? [];
        this.critereRecherche.secteurIds = this.secteursSelected.map(s => s.id);
      }
      this.setCritereRecherche(this.critereRecherche);
    },
    appliquerCritere() {
      this.critereRecherche.commercialId = this.commercialSelected.map((c) => {
        return c.id;
      });
      if (this.critereRecherche.etat?.length) {
        this.critereRecherche.etat = this.critereRecherche.etat.map(item => (typeof item === 'object' ? item.code : item),
        );
      }
      if (this.moduleSecteurActive) {
        this.critereRecherche.secteurIds = this.secteursSelected.map(s => s.id);
      }
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
        await this.loadParametreUtilisateur();
        await updateCritereWithParametreInterne(this.critereRecherche);
        await this.loadParametres([PARAMETRES_KEYS.secteur]);
        this.listeCommercial = initialUsers(this.parametre(PARAMETRES_KEYS.utilisateur)
          .filter(u => u.actif), [DIRECTEUR_COMMERCIAL, COMMERCIAL]);
        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.critereRecherche.commercialId.includes(c.id);
        });
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
          PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
          PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
        ]);
        if (this.moduleSecteurActive) {
          await this.loadParametres([PARAMETRES_KEYS.secteur]);
          this.secteurCurrentUser = await getSecteursIdByUser(SECTEURCOMMERCIAL, true);
          if (this.critereRecherche.secteurIds.length > 0) {
            this.secteursSelected = this.secteurs.filter((s) => {
              return this.critereRecherche.secteurIds.includes(s.id) && s.actif === true;
            });
          }
          if (this.secteurCurrentUser?.length > 0) {
            this.secteursSelected = this.secteurCurrentUser;
          }
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
